import React, { Component } from "react";
import playlistsData from "../data/playlistsData";

import Playlist from './Playlist';

class Playlists extends Component {
    constructor(props) {
        super()
        let playlistsMap = playlistsData[0];
        let playlistsKeys = Object.keys(playlistsMap).reverse()
        this.state = {
            playlistsCards: playlistsKeys.map(key => <Playlist key={key}
                playlistLink={playlistsMap[key].playlistLink}
                playlistTitle={playlistsMap[key].playlistTitle} />)
        }
    }

    render() {
        return (
            <div>
                {this.state.playlistsCards}
            </div>
        );
    }
}

export default Playlists;